<template>
	<section class="section-card" v-loading="loading">
		<div class="section-head">
			<h2 class="section-title">近期告警记录</h2>
		</div>

		<div class="table-box">
			<gc-table
				border
				showPage
				:columns="columns"
				:table-data="alarmRecords"
				:total-hide="false"
				:total="total"
				:current-page.sync="currentPage"
				:page-size="pageSize"
				pagination-layout="prev, next, jumper"
				@current-page-change="handlePageChange"
				@size-change="handleSizeChange"
			/>
		</div>
	</section>
</template>

<script>
import { apiGetPressureRegulatorAlarms } from '@/apis/pressureRegulatorManage.api'

export default {
	name: 'AlarmRecordsSection',
	data() {
		return {
			loading: false,
			alarmRecords: [],
			total: 0,
			currentPage: 1,
			pageSize: 20,
			columns: [
				{ key: 'deviceNo', name: '设备编号', tooltip: true },
				{ key: 'alarmTime', name: '告警时间', tooltip: true },
				{
					key: 'alarmName',
					name: '告警名称',
					tooltip: true,
					render: (h, row) =>
						h(
							'span',
							{ class: `alarm-text alarm-text--${this.getAlarmLevelMeta(row.alarmLevel).key}` },
							row.alarmName,
						),
				},
				{
					key: 'alarmLevel',
					name: '告警等级',
					tooltip: true,
					render: (h, row) => {
						const levelMeta = this.getAlarmLevelMeta(row.alarmLevel)
						return h('span', { class: `status-pill status-pill--${levelMeta.key}` }, levelMeta.label)
					},
				},
			],
		}
	},
	props: {
		regulatorCode: {
			type: String,
			default: '',
		},
	},
	watch: {
		regulatorCode: {
			handler(value) {
				if (value) {
					this.currentPage = 1
					this.getAlarms()
				}
			},
			immediate: true,
		},
	},
	methods: {
		async getAlarms() {
			this.loading = true
			try {
				const data = await apiGetPressureRegulatorAlarms({
					current: this.currentPage,
					size: this.pageSize,
					alarmSeq: 0,
					regulatorCode: this.regulatorCode,
				})
				this.alarmRecords = data.records || []
				this.total = data.total || 0
				this.$emit('status-change', Boolean(this.alarmRecords.length))
			} finally {
				this.loading = false
			}
		},
		handlePageChange(currentPage) {
			this.currentPage = currentPage
			this.getAlarms()
		},
		handleSizeChange(pageSize) {
			this.pageSize = pageSize
			this.currentPage = 1
			this.getAlarms()
		},
		getAlarmLevelMeta(level) {
			const levelMap = {
				0: { label: '一般', key: 'minor' },
				1: { label: '中等', key: 'warning' },
				2: { label: '严重', key: 'danger' },
			}
			return levelMap[level] || { label: '--', key: 'default' }
		},
	},
}
</script>

<style lang="scss" scoped>
.section-card {
	position: relative;
	padding: 22px 24px 0px;
	background: var(--panel-bg);
	border: 1px solid var(--panel-border);
	border-radius: 12px;
	box-shadow: var(--panel-shadow);
	backdrop-filter: blur(12px);
}

.section-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	margin-bottom: 18px;
}

.section-title {
	margin: 0;
	color: var(--title);
	font-size: 17px;
	font-weight: 700;
	letter-spacing: 0.01em;
}

.section-head__meta {
	font-size: 13px;
	color: var(--muted);
}

.table-box {
	height: 524px;
}

::v-deep .status-pill {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-height: 24px;
	padding: 2px 10px;
	border-radius: 12px;
	font-size: 14px;
	font-weight: 400;
	white-space: nowrap;
}

::v-deep .status-pill--minor {
	background: #ffedd5;
	color: #f97316;
}

::v-deep .status-pill--warning {
	background: #fef9c3;
	color: #ca8a04;
}

::v-deep .status-pill--danger {
	background: #fee2e2;
	color: #dc2626;
}

::v-deep .status-pill--default {
	background: #f1f5f9;
	color: #64748b;
}

::v-deep .alarm-text--danger {
	color: var(--danger);
	font-weight: 400;
}

::v-deep .alarm-text--warning {
	color: var(--warning);
	font-weight: 400;
}

::v-deep .alarm-text--minor {
	color: var(--minor);
	font-weight: 400;
}

@media (max-width: 900px) {
	.section-head {
		flex-direction: column;
		align-items: flex-start;
	}
}
</style>
